import AppId from "~/utils/partner";

const getTitleandUrl = (route, hospitalSelected = null) => {
  if (
    hospitalSelected &&
    (route === hospitalSelected.partnerId || route === hospitalSelected.id)
  ) {
    return {
      title: hospitalSelected.name || hospitalSelected.desc2 || route,
      url: "",
      isActive: false
    };
  }

  switch (route) {
    case "":
      return {
        title: "Trang chủ",
        url: "/",
        isActive: false
      };
    case "login":
      return {
        title: "Đăng nhập",
        url: "/login",
        isActive: false
      };
    case "huong-dan":
      return {
        title: "Hướng dẫn",
        url: "/huong-dan",
        isActive: false
      };
    case "chon-benh-vien":
      return {
        title: "Chọn bệnh viện",
        url: "/chon-benh-vien",
        isActive: false
      };
    case "thanh-toan-tien-ich-offline":
      return {
        title: "THANH TOÁN OFFLINE QUA CỬA HÀNG",
        url: "/thanh-toan-tien-ich-offline",
        isActive: false
      };
    case "umc":
      return {
        title: "BV Đại Học Y Dược",
        url: "",
        isActive: false
      };
    case "dalieuhcm":
      return {
        title: "BV Da liễu",
        url: "",
        isActive: false
      };
    case "nhidong1":
      return {
        title: "BV Nhi Đồng 1",
        url: "",
        isActive: false
      };
    case "minhanh":
      return {
        title: "BV Minh Anh",
        url: "",
        isActive: false
      };
    case "ctchhcm":
      return {
        title: "BV CTCH",
        url: "",
        isActive: false
      };
    case "trungvuong":
      return {
        title: "BV Trưng Vương",
        url: "",
        isActive: false
      };
    case "115":
      return {
        title: "BV 115",
        url: "",
        isActive: false
      };
    case "bthh":
      return {
        title: "BV TMHH",
        url: "",
        isActive: false
      };
    case "vanhanh":
      return {
        title: "BV Vạn Hạnh",
        url: "",
        isActive: false
      };
    case "dkkvangiang":
      return {
        title: "BV ĐKKV An Giang",
        url: "",
        isActive: false
      };
    case "dkdongnai":
      return {
        title: "BV ĐK Đồng Nai",
        url: "",
        isActive: false
      };
    case "dkvinhlong":
      return {
        title: "BV ĐK Vĩnh Long",
        url: "",
        isActive: false
      };
    case "noitiettw":
      return {
        title: "BV Nội tiết TW",
        url: "",
        isActive: false
      };
    case "choray":
      return {
        title: "BV Chợ Rẫy",
        url: "",
        isActive: false
      };
    case "leloi":
      return {
        title: "BV Vũng Tàu",
        url: "",
        isActive: false
      };
    case "yduoccs2":
      return {
        title: "BV ĐH Y Dược CS2",
        url: "",
        isActive: false
      };
    case "thuduc":
      return {
        title: "BV Quận Thủ Đức",
        url: "",
        isActive: false
      };
    case "dat-kham-theo-ngay":
      return {
        title: "Đặt khám theo ngày",
        url: "",
        isActive: false
      };
    case "chon-ho-so":
      return {
        title:
          AppId === "dkanphuoc"
            ? "Chọn hồ sơ đặt khám"
            : "Chọn hồ sơ bệnh nhân",
        url: "",
        isActive: false
      };
    case "chon-chuyen-khoa":
      return {
        title: "Chọn chuyên khoa",
        url: "",
        isActive: false
      };
    case "chon-bac-si":
      return {
        title: "Chọn bác sĩ",
        url: "",
        isActive: false
      };
    case "dat-lich-theo-bac-si":
      return {
        title: "Chọn Ngày khám - Giờ khám - BHYT",
        url: "",
        isActive: false
      };
    case "chon-dich-vu":
      return {
        title: "Chọn dịch vụ",
        url: "",
        isActive: false
      };
    case "chon-lich-kham":
      return {
        title: "Chọn lịch khám",
        url: "",
        isActive: false
      };
    case "lich-tai-kham":
      return {
        title: "Lịch tái khám",
        url: "",
        isActive: false
      };
    case "danh-sach-lich-tai-kham":
      return {
        title: "Danh sách lịch tái khám",
        url: "",
        isActive: false
      };
    case "chon-lich-tai-kham":
      return {
        title: "Chọn lịch tái khám",
        url: "",
        isActive: false
      };
    case "chon-phong-kham":
      return {
        title: "Chọn phòng khám",
        url: "",
        isActive: false
      };
    case "tim-lai-ma-benh-nhan":
      return {
        title: "Tìm lại mã bệnh nhân",
        url: "",
        isActive: false
      };
    case "ket-qua-tim-benh-nhan":
      return {
        title: "Kết quả tìm kiếm bệnh nhân",
        url: "",
        isActive: false
      };
    case "xac-nhan-thong-tin":
      return {
        title: "Xác nhận thông tin",
        url: "",
        isActive: false
      };
    case "xac-thuc-dien-thoai-benh-nhan":
      return {
        title: "Xác thực thông tin",
        url: "",
        isActive: false
      };
    case "hinh-thuc-thanh-toan":
      return {
        title: "Thanh toán",
        url: "",
        isActive: false
      };
    case "faq":
      return {
        title: "Các câu hỏi thường gặp",
        url: "",
        isActive: false
      };
    case "lien-he":
      return {
        title: "Liên hệ",
        url: "",
        isActive: false
      };
    case "quy-trinh":
      return {
        title: "Quy trình",
        url: "",
        isActive: false
      };
    case "gioi-thieu":
      return {
        title: "Giới thiệu",
        url: "",
        isActive: false
      };
    case "tin-tuc":
      return {
        title: "Tin tức",
        url: "",
        isActive: false
      };
    case "user":
      return {
        title: "Thông tin tài khoản",
        url: "",
        isActive: false
      };
    case "chi-tiet-phieu-kham-benh":
      return {
        title: "Thông tin phiếu khám bệnh",
        url: "",
        isActive: false
      };
    case "phieu-kham-benh":
      return {
        title: "Thông tin phiếu khám bệnh",
        url: "",
        isActive: false
      };
    case "ho-so-benh-nhan":
      return {
        title: "Hồ sơ bệnh nhân",
        url: "",
        isActive: false
      };
    case "tao-moi-ho-so":
      return {
        title: "Tạo hồ sơ bệnh nhân",
        url: "",
        isActive: false
      };
    case "cap-nhat-thong-tin":
      return {
        title: "Cập nhật thông tin",
        url: "",
        isActive: false
      };
    case "xac-nhan-thong-tin-benh-nhan":
      return {
        title: "Xác nhận thông tin bệnh nhân",
        url: "",
        isActive: false
      };
    case "tim-ma-thanh-toan-vien-phi":
      return {
        title: "Thanh toán viện phí",
        url: "",
        isActive: false
      };
    case "hinh-thuc-thanh-toan-vien-phi":
      return {
        title: "Hình thức thanh toán viện phí",
        url: "",
        isActive: false
      };
    case "lich-su-thanh-toan-vien-phi":
      return {
        title: "Lịch sử thanh toán viện phí",
        url: "",
        isActive: false
      };
    case "ho-tro-thanh-toan":
      return {
        title: "Hỗ trợ thanh toán",
        url: "",
        isActive: false
      };
    case "thanh-toan-ho":
      return {
        title: "Thanh toán hộ",
        url: "",
        isActive: false
      };
    case "thong-bao":
      return {
        title: "Thông báo",
        url: "",
        isActive: false
      };
    case "search":
      return {
        title: "Tìm kiếm",
        url: "",
        isActive: false
      };
    case "chi-tiet-ma-thanh-toan":
      return {
        title: "Thông tin thanh toán viện phí",
        url: "",
        isActive: false
      };
    case "khai-bao-ho-so-doanh-nghiep":
      return {
        title: "Khai báo hồ sơ doanh nghiệp",
        url: "",
        isActive: false
      };
    case "khai-bao-ho-so-ca-nhan":
      return {
        title: "Khai báo hồ sơ cá nhân",
        url: "",
        isActive: false
      };

    case "huong-dan-bao-hiem-y-te-trai-tuyen":
    case "huong-dan-bao-hiem-y-te-trai-tuyen-dalieuhcm":
      return {
        title: "Hướng dẫn BHYT trái tuyến",
        url: "",
        isActive: false
      };
    case "tra-ket-qua-kham-benh-nhidonghcm":
      return {
        title: "Trả kết quả khám bệnh",
        url: "/tra-ket-qua-kham-benh-nhidonghcm",
        isActive: false
      };

    case "ket-qua-thanh-toan-vien-phi":
      return {
        title: "Kết quả thanh toán viện phí",
        url: "/ket-qua-thanh-toan-vien-phi",
        isActive: false
      };

    case "chon-hinh-thuc-dat-kham": {
      const partnerId = hospitalSelected ? (hospitalSelected.partnerId || hospitalSelected.id) : null;
      return {
        title: "Hình thức đặt khám",
        url: partnerId ? `/${partnerId}/chon-hinh-thuc-dat-kham` : "/chon-hinh-thuc-dat-kham",
        isActive: false
      };
    }
    case "chon-dich-vu-tiem-chung":
      return {
        title: "Chọn dịch vụ tiêm chủng",
        url: "/chon-dich-vu-tiem-chung",
        isActive: false
      };
    case "chon-goi-tiem-chung":
      return {
        title: "Chọn gói tiêm chủng",
        url: "/chon-goi-tiem-chung",
        isActive: false
      };
    case "chon-loai-vaccin":
      return {
        title: "Chọn loại vaccin",
        url: "/chon-loai-vaccin",
        isActive: false
      };

    default:
      return null;
  }
};

export const breadCrumb = (pathname = "", hospitalSelected = null) => {
  return pathname
    .split("/")
    .map(route => getTitleandUrl(route, hospitalSelected));
};
